import { PeriodBucketKind } from '@lla-platform/core/core-data-access'
import { TABLE_CONSTANTS } from '@lla-platform/core/core-util'

/** One location row of a trend view: a location (or the Grand Total) and its per-bucket points. */
export interface ITrendRow<P> {
  locationId: string
  locationName: string
  points: P[]
}

/**
 * Chart rows in table order: each table row (the sorted data source, Grand Total last when present) matched
 * to its trend location by id; the Grand Total row takes the response's grand-total points.
 */
export const trendChartRows = <P>(
  rows: { locationId?: string }[],
  locations: ITrendRow<P>[],
  grandTotal: P[]
): ITrendRow<P>[] => {
  const byLocationId = new Map(locations.map((el) => [el.locationId, el]))
  return rows
    .map((row) =>
      row.locationId === TABLE_CONSTANTS.GRAND_TOTAL_ID
        ? { locationId: TABLE_CONSTANTS.GRAND_TOTAL_ID, locationName: 'Grand Total', points: grandTotal }
        : byLocationId.get(row.locationId ?? '')
    )
    .filter((row): row is ITrendRow<P> => !!row)
}

export const trendCaption = (bucketKind: PeriodBucketKind, count: number): string => {
  const weekly = bucketKind === PeriodBucketKind.Week
  return `${weekly ? 'Weekly' : 'Monthly'} buckets · ${count} ${weekly ? 'week' : 'month'}${count === 1 ? '' : 's'}`
}
